<template>
  <div class="coupon-selector" v-if="usableList.length || unusableList.length">

    <div class="scroll-container">
      <div class="coupon-group">
        <div v-for="item in usableList" :key="item.claimRecordId" class="coupon-card usable" :class="{
          selected: item.selected,
          'has-footer': item.reason
        }">
          <div class="card-main">
            <div class="left-part">
              <div class="price">
                <template v-if="item.discountType === 3">
                  <span class="num">{{ item.showNumber }}</span>
                  <span class="symbol">折</span>
                </template>
                <template v-else>
                  <span class="symbol">¥</span>
                  <span class="num">{{ item.showNumber }}</span>
                </template>
              </div>
              <div class="condition">{{ item.showTip }}</div>
            </div>

            <div class="divider-line"></div>

            <div class="right-part">
              <div class="info">
                <div class="name">
                  {{ item.couponName }}
                </div>
                <div class="date">{{ item.expireTime }}</div>
              </div>

              <div class="checkbox-area" @click="toggleSelect(item)">
                <div v-if="item.selected" class="check-icon checked">
                  <van-icon name="success" />
                </div>
                <div v-else class="check-icon unchecked"></div>
              </div>
            </div>
          </div>

          <div class="card-footer-strip" v-if="item.reason">
            {{ item.reason }}
          </div>
        </div>
      </div>

      <div class="disabled-header" v-if="unusableList.length > 0">
        该订单不可使用的优惠券（{{ unusableList.length }}张）
      </div>

      <div class="coupon-group">
        <div v-for="item in unusableList" :key="item.claimRecordId" class="coupon-card disabled"
          :class="{ 'has-footer': item.reason }">
          <div class="card-main">
            <div class="left-part">
              <div class="price">
                <template v-if="item.discountType === 3">
                  <span class="num">{{ item.showNumber }}</span>
                  <span class="symbol">折</span>
                </template>
                <template v-else>
                  <span class="symbol">¥</span>
                  <span class="num">{{ item.showNumber }}</span>
                </template>
              </div>
              <div class="condition">{{ item.showTip }}</div>
            </div>

            <div class="divider-line"></div>

            <div class="right-part">
              <div class="info">
                <div class="name">{{ item.couponName }}</div>
                <div class="date">{{ item.expireTime }}</div>
              </div>

              <div class="checkbox-area">
                <div class="check-icon disabled-circle"></div>
              </div>
            </div>
          </div>

          <div class="card-footer-strip reason-strip" v-if="item.reason">
            {{ item.reason }}
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-action-bar">
      <div class="confirm-btn" @click="handleConfirm">
        确定
      </div>
    </div>
  </div>

  <div class="no-data" v-else>
    <img class="package-empty-icon" src="@/assets/empty-order.png" />
    <p class="package-empty-text">暂无优惠券!</p>
  </div>

</template>

<script>
import { getCouponListBySn } from "@/api/user";
import { formatCouponItem } from "../../utils/couponUtils";

export default {
  data() {
    return {
      primaryColor: '',

      isUpgrade: 0, //是否套餐升级：0否，1是 必传
      sn: "",
      packageId: "",
      amount: "",

      usableList: [],   //可用
      unusableList: [], //不可用

      lastSelectedId: "",//选中的套餐ID
      claimRecordId: "",//优惠券ID
    };
  },

  mounted() {
    this.initThemeColor();

    this.isUpgrade = this.$route.query.isUpgrade;
    this.sn = this.$route.query.sn;
    this.packageId = this.$route.query.packageId;
    this.amount = this.$route.query.amount;

    this.lastSelectedId = this.$route.query.lastSelectedId;
    this.claimRecordId = this.$route.query.claimRecordId;

    this.listAction();
  },
  methods: {
    initThemeColor() {
      const color = getComputedStyle(document.documentElement)
        .getPropertyValue("--primary-color")
        .trim();

      if (color) {
        this.primaryColor = color;
      }
      // 设置 CSS 变量供样式使用
      this.$el.style.setProperty('--primary-color', this.primaryColor);
      this.$el.style.setProperty('--primary-light-bg', this.convertColorToRgba(this.primaryColor, 0.1));
      this.$el.style.setProperty('--primary-line-bg', this.convertColorToRgba(this.primaryColor, 0.3));
    },

    convertColorToRgba(colorStr, opacity) {
      if (!colorStr) return `rgba(253, 141, 50, ${opacity})`;
      if (colorStr.startsWith("#")) {
        const hex = colorStr.replace("#", "");
        let r, g, b;
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      }
      return colorStr;
    },

    toggleSelect(item) {
      if (item.selected) {
        item.selected = false;
      } else {
        this.usableList.forEach(coupon => {
          coupon.selected = false;
        });
        item.selected = true;
      }
    },

    handleConfirm() {
      const selectedItem = this.usableList.find(i => i.selected);

      if (selectedItem) {
        sessionStorage.setItem('selected_coupon_data', JSON.stringify(selectedItem));
      } else {
        sessionStorage.removeItem('selected_coupon_data');
      }

      sessionStorage.setItem('lastSelectedId', this.lastSelectedId);
      // 返回上一页
      this.uni.navigateBack();
    },


    listAction() {
      const params = {
        sn: this.sn, //设备sn
        packageId: this.packageId, //套餐ID
        amount: this.amount, //套餐原价（元）
        isUpgrade: this.isUpgrade, //是否套餐升级：0否，1是 必传
      };

      getCouponListBySn(params).then((res) => {

        /* 可用部分 */
        this.usableList = (res.usableList || []).map(item => formatCouponItem(item));


        let hasSelected = false;

        // 1. 如果有传入的 claimRecordId，尝试在列表中找到它并选中
        if (this.claimRecordId) {
          const targetItem = this.usableList.find(item => item.claimRecordId == this.claimRecordId);
          if (targetItem) {
            targetItem.selected = true;
            hasSelected = true;
          }
        }

        // 2. 如果没有匹配到（或者没有传入ID），且列表不为空，默认选中第一个
        if (!hasSelected && this.usableList.length > 0) {
          this.usableList[0].selected = true;
        }

        /* 不可用部分 */
        this.unusableList = (res.unusableList || []).map(item => formatCouponItem(item));
      });
    }
  }
};
</script>

<style lang="less" scoped>
.coupon-selector {
  min-height: 100vh;
  background-color: #F2F2F2;
  display: flex;
  flex-direction: column;
}

.scroll-container {
  flex: 1;
  overflow-y: auto;
  padding: 32px 32px 240px;
}

.disabled-header {
  margin: 30px 0 30px;
  font-size: 32px;
  color: #000;
}

.coupon-card {
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 24px;
  transition: all 0.2s;

  /* 当 has-footer 类存在时，隐藏底部的半圆 */
  &.has-footer {
    .card-main .divider-line::after {
      display: none;
    }
  }

  /* 1. 可用状态样式 */
  &.usable {
    background-color: #fff;

    .card-main {
      background-color: var(--primary-light-bg);

      .left-part {
        color: var(--primary-color);
      }

      .right-part .name {
        color: #333;
      }

      .divider-line {
        border-left-color: var(--primary-line-bg)
      }
    }

    .card-footer-strip {
      background-color: #fff;
      color: #333;
    }
  }

  /* 2. 不可用状态样式 */
  &.disabled {
    background-color: #fff;

    .card-main {
      background-color: #fff;

      .left-part {
        color: var(--primary-color);
        opacity: 0.5;
      }

      .right-part {
        .name {
          opacity: 0.5;
        }

        .date {
          opacity: 0.5;
        }
      }

      .divider-line {
        border-left-color: #EEE;
      }
    }

    .card-footer-strip {
      background-color: var(--primary-light-bg);
      color: #999;
    }
  }

  .card-main {
    display: flex;
    align-items: stretch;
    height: 160px;
    padding: 0;
    position: relative;

    .left-part {
      width: 180px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      .price {
        font-weight: bold;
        display: flex;
        align-items: baseline;

        .symbol {
          font-size: 32px;
          margin-right: 4px;
        }

        .num {
          font-size: 58px;
          line-height: 1;
        }
      }

      .condition {
        font-size: 22px;
        margin-top: 10px;
      }
    }

    /* === 分割线与半圆 === */
    .divider-line {
      width: 1px;
      margin: 0 10px;
      border-left: 2px dashed #ddd;
      position: relative;
      align-self: stretch;

      /* 伪元素创建半圆 */
      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 32px;
        height: 32px;
        background-color: #F2F2F2;
        /* 背景色 */
        border-radius: 50%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 5;
      }

      /* 顶部半圆 */
      &::before {
        top: -16px;
      }

      /* 底部半圆 (会被 has-footer 隐藏) */
      &::after {
        bottom: -16px;
      }
    }

    .right-part {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px;

      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .name {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 26px;
          color: #24262B;
        }

        .date {
          font-size: 24px;
          color: var(--primary-color);
        }
      }

      .checkbox-area {
        margin-left: 20px;

        .check-icon {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          &.checked {
            background-color: var(--primary-color);
            color: #fff;
            font-size: 32px;
          }

          &.unchecked {
            border: 2px solid #ccc;
          }

          &.disabled-circle {
            border: 2px solid #eee;
          }
        }
      }
    }
  }

  .card-footer-strip {
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 32px;
    font-size: 24px;
  }
}


/* 底部固定按钮区域 */
.bottom-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 32px;
  padding-bottom: calc(10px + constant(safe-area-inset-bottom));
  padding-bottom: calc(10px + env(safe-area-inset-bottom));

  z-index: 10;

  .confirm-btn {
    height: 88px;
    width: 100%;
    background-color: var(--primary-color);
    border-radius: 44px;
    color: #fff;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

  }
}

.no-data {

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .package-empty-icon {
    margin-top: 120px;
    width: 342px;
    height: 264px;
  }

  .package-empty-text {
    font-size: 30px;
    color: #666666;
    margin-top: 72px;

    // .package-empty-text-tip {
    //   color: var(--primary-color);
    // }
  }
}
</style>